/* istanbul ignore file */
import { useAsyncValue } from 'framework/utils';
import useAuthenticatedUserService from 'infrastructure/security/authentication/authenticatedUserService';

const SignatureOptionTooltip = () => {
  const { getUserAlias } = useAuthenticatedUserService();
  const userAlias = useAsyncValue(() => getUserAlias());

  return (
    <>
      Legal service engineer will contact you when documents are ready for signing. You can also view the status of your
      request on the{' '}
      <a href={`/workers/${userAlias}/leaves`} target="_blank" rel="noopener noreferrer">
        Leave page
      </a>
    </>
  );
};

export default SignatureOptionTooltip;
